// extracted by mini-css-extract-plugin
export var pillWrapper = "_pu-0";
export var showOverflow = "_pu-1";